import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useSeverityBadgeStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.padding('2px', '8px'),
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase200,
    textTransform: 'uppercase',
    minWidth: '80px',
  },
  large: {
    fontSize: tokens.fontSizeBase400,
    ...shorthands.padding('4px', '12px'),
    minWidth: '100px',
  },
  high: {
    backgroundColor: '#e74856',
    color: tokens.colorNeutralForegroundOnBrand,
  },
  medium: {
    backgroundColor: '#ff8c00',
    color: '#1b1a19',
  },
  low: {
    backgroundColor: '#fce100',
    color: '#1b1a19',
  },
  informational: {
    backgroundColor: '#0078d4',
    color: tokens.colorNeutralForegroundOnBrand,
  },
});
